// extracted by css-extract-rspack-plugin
export default {"cls1":"AffiliationPrompt-cls1_eEj","cls2":"AffiliationPrompt-cls2_DgN AffiliationPrompt-cls1_eEj"};